"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var awsui_button_1 = require("../button/awsui-button");
var awsui_form_1 = require("../form/awsui-form");
var WizardWrapper = /** @class */ (function (_super) {
    __extends(WizardWrapper, _super);
    function WizardWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WizardWrapper.prototype.findInfo = function () {
        return this.find('.awsui-wizard__info');
    };
    WizardWrapper.prototype.findCancelButton = function () {
        return this.findComponent('.awsui-wizard__cancel-button', awsui_button_1.default);
    };
    WizardWrapper.prototype.findPreviousButton = function () {
        return this.findComponent('.awsui-wizard__previous-button', awsui_button_1.default);
    };
    WizardWrapper.prototype.findPrimaryButton = function () {
        return this.findComponent('.awsui-wizard__primary-button', awsui_button_1.default);
    };
    WizardWrapper.prototype.findMenuNavigationLinks = function () {
        return this.findAll('.awsui-wizard__navigation-link');
    };
    /**
     * Returns a link for a given step number.
     *
     * @param stepNumber 1-based step index
     */
    WizardWrapper.prototype.findMenuNavigationLink = function (stepNumber) {
        return this.find(".awsui-wizard__navigation-link-item:nth-child(" + stepNumber + ") .awsui-wizard__navigation-link");
    };
    return WizardWrapper;
}(awsui_form_1.default));
exports.default = WizardWrapper;
//# sourceMappingURL=awsui-wizard.js.map